import { useState } from "react";
import { Table, Button, message } from "antd";
import Page from "component/Page/index";
import { PlayCircleOutlined } from "@ant-design/icons";
import { useCommonManagerActions } from "@iso/actions/commonManager.actions";

const ClearCache = () => {
   const [loadActive, setLoadActive] = useState({ loading: false, type: "" });
   const { clearCacheKMS } = useCommonManagerActions();

   const [data, _] = useState({
      dataSource: [
         {
            title: "[KMS VN] Clear POS COS",
            type: "vn-cache-cos",
         },
         {
            title: "[KMS IN] Clear POS COS",
            type: "indian-cache-cos",
         },
         {
            title: "[KMS JP] Clear POS COS",
            type: "jp-cache-cos",
         },
         {
            title: "[KMS VN] Clear POS 4PS",
            type: "vn-cache-4ps",
         },
      ],
      paging: {
         current: 1,
         total: 0,
         pageSize: 10,
      },
   });

   const handleClearCacheKMS = async (langId) => {
      try {
         await clearCacheKMS(langId);
         message.success("Clear cache successfully");
         setLoadActive({ loading: false, type: "" });
      } catch (err) {
         message.error("Clear cache failed");
         setLoadActive({ loading: false, type: "" });
      }
   };

   const handleClearCache = (type) => {
      setLoadActive({ loading: true, type });
      switch (type) {
         case 'vn-cache-4ps':
            return handleClearCacheKMS('vi-4ps');
         case 'vn-cache-cos':
            return handleClearCacheKMS('vi-cos');
         case 'indian-cache-cos':
            return handleClearCacheKMS('in-cos');
         case 'jp-cache-cos':
            return handleClearCacheKMS('jp-cos');
         default:
            setLoadActive({ loading: false, type });
            return;
      }
   };

   const columns = [
      {
         title: "Title",
         dataIndex: "title",
         key: "title",
      },
      {
         title: "Action",
         width: "10%",
         align: "center",
         fixed: "right",
         render: (_, record) => (
            <div className="flex justify-center gap-3">
               <Button
                  loading={
                     loadActive?.loading && loadActive?.type === record?.type
                  }
                  onClick={() => handleClearCache(record?.type)}
                  icon={<PlayCircleOutlined />}
                  type="primary"
               ></Button>
            </div>
         ),
      },
   ];

   return (
      <Page title="Clear Cache Management">
         <Table
            columns={columns}
            rowKey="key"
            dataSource={data.dataSource}
            pagination={null}
            loading={false}
         />
      </Page>
   );
};

export default ClearCache;
